<script setup>
import NewPC from "../components/NewPC/PcBlock.vue";
import CustomMenu from "@/components/NewPC/CustomMenu.vue";
import FirstScreen from "@/components/NewPC/FirstScreen.vue";
import CustomFooter from "@/components/NewPC/CustomFooter.vue";
import SecondScreen from "@/components/NewPC/SecondScreen.vue";
import ThirdScreen from "@/components/NewPC/ThirdScreen.vue";
import FourthScreen from "@/components/NewPC/FourthScreen.vue";
import {onMounted, ref} from "vue";
import {useTgaStore} from "@/store/tga.js";
import useAccount from "@/store/account";
import {useRoute} from "vue-router";
const route = useRoute();
const tga = useTgaStore()
const accountStore = useAccount();
const ScrollContainer = ref(null);
const showGiftEntry = ref(false);
const handleJumpMode = id => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

const handleUploadTag = () => {
  tga.tgaLogin("202504_GUANWANG", accountStore.getterAccount() ? accountStore.getterAccount():'未绑定');
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_page_exposure',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "首页"
  })
}

const handleJumpGift = () => {
  const element = document.getElementById('gift');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

const handleScroll = () => {
  if (ScrollContainer.value.scrollTop > 200) {
    showGiftEntry.value = true;
  } else {
    showGiftEntry.value = false;
  }
};

onMounted(() => {
  const anchor = route.query.anchor;
  if (anchor) {
    handleJumpMode(anchor);
  }
  handleUploadTag()

  if (ScrollContainer.value) {
    ScrollContainer.value.addEventListener('scroll', handleScroll);
  }
})


</script>

<template>
  <div class="scroll-container"  ref="ScrollContainer">
    <div class="first_screen">
      <new-p-c class="scroll-section">
        <template #default>
          <custom-menu :active="0" />
          <first-screen />
        </template>
      </new-p-c>
    </div>
    <new-p-c class="scroll-section">
      <template #default>
        <second-screen />
      </template>
    </new-p-c>
    <new-p-c class="scroll-section">
      <template #default>
        <third-screen />
      </template>
    </new-p-c>
    <new-p-c class="scroll-section" id="gift">
      <template #default>
        <fourth-screen />
      </template>
    </new-p-c>
    <custom-footer class="footer_block"/>

    <img v-if="showGiftEntry" class="gift_entry" @click="handleJumpGift" src="@/assets/newPc/gift_entry.png" alt="">
  </div>
</template>

<style scoped lang="scss">
@import "@/style/fonts.scss";
/* 滚动容器 */
.scroll-container {
  display: flex;
  flex-direction: column; /* 垂直方向滚动 */
  height: 100vh; /* 占满视口高度 */
  overflow-y: scroll; /* 启用垂直滚动 */
  scrollbar-width: none;
  scroll-snap-type: y mandatory; /* 强制垂直方向吸附 */
  overflow-x: hidden;
}

/* 每屏内容 */
.scroll-section {
  flex: none; /* 防止子元素自动缩放 */
  width: 100%; /* 占满容器宽度 */
  //aspect-ratio: 16 / 9; /* 保持 16:9 比例 */
  scroll-snap-align: start; /* 吸附到容器顶部 */
  font-size: 32px;
  color: white;
}

.first_screen {
  width: 100vw;
  height: 100vh;
  background: transparent url("../assets/newPc/first_screen_bg.jpg") no-repeat center center;
  background-size: cover;
  position: relative;
}

.footer_block {
  height: 12.5vw;
  scroll-snap-align: end; /* 吸附到容器顶部 */
  flex: none; /* 防止子元素自动缩放 */
  width: 100%; /* 占满容器宽度 */
  font-size: 32px;
  color: white;
}

.gift_entry {
  position: fixed;
  top: 29.5703125vw;
  right: 1.640625vw;
  z-index: 1;
  width: 9.0625vw;
  height: 6.171875vw;
}

</style>